<template lang="html">
    <ModalDefault
        v-if="params && params.isActive"
        size="s"
        :with-content="true"
        @close="close()"
        :theme="true"
        :fix-height="false"
        :fix-width="false"
        :loading="false"
    >
        <template slot="main">
            <div class="row d-flex align-items-center">
                <div class="col">
                    <p class="name">{{ params.periodHasComponent.component.cpntName }}</p>
                    <p class="sap">SAP : {{ params.periodHasComponent.component.codeSap }}</p>
                    <p class="ean">EAN : {{ params.periodHasComponent.component.codeEan }}</p>
                </div>
                <div class="col" v-if="hasImg">
                    <img
                        v-if="params.periodHasComponent.component.cpntImd"
                        :src="params.periodHasComponent.component.cpntImd"
                        style="max-height: 200px"
                    />
                    <img v-else src="../../../../static/img/no_image.jpg" style="max-height: 200px" />
                </div>
            </div>

            <div class="table-responsive mt-4">
                <table>
                    <tr>
                        <td>{{ $t("catalogForecast.market.productHierarchyLabel") }} 1</td>
                        <td>{{ params.periodHasComponent.component.cateName1 }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t("catalogForecast.market.productHierarchyLabel") }} 2</td>
                        <td>{{ params.periodHasComponent.component.cateName2 }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t("catalogForecast.market.productHierarchyLabel") }} 3</td>
                        <td>{{ params.periodHasComponent.component.cateName3 }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t("catalogForecast.market.productHierarchyLabel") }} 4</td>
                        <td>{{ params.periodHasComponent.component.cateName4 }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t("catalogForecast.market.productHierarchyLabel") }} 5</td>
                        <td>{{ params.periodHasComponent.component.cateName5 }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t("catalogForecast.market.typeLabel") }}</td>
                        <td>{{ params.periodHasComponent.component.type }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t("catalogForecast.market.statusLabel") }}</td>
                        <td>{{ params.periodHasComponent.component.statusName.toUpperCase() }}</td>
                    </tr>
                    <!--                    <tr>-->
                    <!--                        <td>{{ $t("catalogForecast.market.quotaLabel") }}</td>-->
                    <!--                        <td>{{ getPropertyValue(params.periodHasComponent.component.quota) }}</td>-->
                    <!--                    </tr>-->
                    <tr>
                        <td>{{ $t("catalogForecast.market.labOfficeLabel") }}</td>
                        <td>{{ getPropertyValue(params.periodHasComponent.component.labOffice) }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t("catalogForecast.market.parentCodeLabel") }}</td>
                        <td>{{ getPropertyValue(params.periodHasComponent.component.parentCode) }}</td>
                    </tr>
                    <!--                    <tr>-->
                    <!--                        <td>{{ $t("catalogForecast.market.switchToCatalogDateLabel") }}</td>-->
                    <!--                        <td>{{ getPropertyDateValue(params.periodHasComponent.component.switchToCatalogDate) }}</td>-->
                    <!--                    </tr>-->
                    <!-- <tr> -->
                    <!-- <td>{{ $t('catalogForecast.market.unitPerBoxLabel') }}</td> -->
                    <!-- <td>{{ getPropertyValue(params.periodHasComponent.component.unitPerBox) }}</td> -->
                    <!-- </tr> -->
                    <!-- <tr> -->
                    <!-- <td>{{ $t('catalogForecast.market.srpLabel') }}</td> -->
                    <!-- <td>{{ getPropertyValue(params.periodHasComponent.component.srp) }}</td> -->
                    <!-- </tr> -->
                    <!-- <tr> -->
                    <!-- <td>{{ $t('catalogForecast.market.preseriesDateLabel') }}</td> -->
                    <!-- <td>{{ getPropertyDateValue(params.periodHasComponent.component.preseriesDate) }}</td> -->
                    <!-- </tr> -->
                </table>
            </div>
        </template>
    </ModalDefault>
</template>

<script lang="js">
import ModalDefault from "@/components/ui/ModalDefault";
import DefaultTextareaInputBloc from "@/components/ui/Form/DefaultTextareaInputBloc";
import moment from "moment";

export default {
    components: {DefaultTextareaInputBloc, ModalDefault},
    props: ['params'],
    data () {
        return {
        }
    },
    methods: {
        getPropertyValue(property) {
            return property !== null ? property : '-';
        },
        getPropertyDateValue(property) {
            return moment(property, 'YYYYMMDD', true).isValid() ? moment(property).format('YYYY-MM-DD') : '-';
        },
        close() {
            this.params.isActive = false;
            this.$emit('close');
        }
    },
    computed: {
        hasImg() {
            return this.params.paramAddImagesToArticles && parseInt(this.params.paramAddImagesToArticles.value, 10);
        }
    }
}
</script>

<style scoped lang="scss">
.name,
.sap,
.ean {
    text-align: center;
    font-size: 16px;
    margin-bottom: 5px;
}
.name {
    font-family: "oswald", Sans-Serif;
    font-size: 20px;
}
table {
    width: 100%;
    tr {
        td {
            border: 1px solid #2d2d2d;
            padding: 10px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// ComponentInfos.vue?7a48925d